import { render, staticRenderFns } from "./CommandBar.vue?vue&type=template&id=3cec75f6&scoped=true"
import script from "./CommandBar.vue?vue&type=script&lang=ts"
export * from "./CommandBar.vue?vue&type=script&lang=ts"
import style0 from "./CommandBar.vue?vue&type=style&index=0&id=3cec75f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec75f6",
  null
  
)

export default component.exports